"use strict";
import $ from "jquery";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  index: function() {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/factoring_companies/",
        type: "get",
        contentType: "application/json"
      })
    ).then(function(data) {
      DataStoreService.updateStores(data);
      return data;
    });
  },
  byCarrierInvoiceId: function(carrierInvoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: `/api/factoring_companies/by_carrier_invoice?carrier_invoice_id=${carrierInvoiceId}`,
        type: "get",
        contentType: "application/json"
      })
    ).then(function(data) {
      DataStoreService.updateStores(data);
      return data;
    });
  }
};
